import React from "react";

const ContactPage: React.FC = () => {
  return (
    <div>
      <h1>Contactez-nous</h1>
      <p>
        <strong>Méli Mel’O</strong><br />
        Ouvert du lundi au vendredi de 7h30 à 18h30<br />
        <strong>Adresse :</strong> 100 rue de la mairie, 59630 Bourbourg<br />
        <strong>Téléphone :</strong> 06.99.09.04.93<br />
        <strong>Email :</strong> <a href="mailto:melimelo59630@gmail.com">melimelo59630@gmail.com</a>
      </p>
    </div>
  );
};

export default ContactPage;
